module.exports = __webpack_public_path__ + "static/img/download-newBg.d57526b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/download-newBg.jpg
// module id = miDJ
// module chunks = 0